export default "__VITE_ASSET__b8dbe5dd__"